import * as Styled from './tab-panel.style';

export const TabPanel = Styled.TabPanel;
